import isString from "lodash/isString";
import { PageResponseDto } from "../../model/meta/PageResponseDto";
import { AssignTaskDto } from "../../model/shared/dto/AssignTaskDto";
import { CreateTaskDto } from "../../model/task/dto/CreateTaskDto";
import { DeleteTaskDto } from "../../model/task/dto/DeleteTaskDto";

import { GenericGetTasksDto } from "../../model/task/dto/GenericGetTasksDto";
import { GetTasksSettingsDto } from "../../model/task/dto/GetTasksSettingsDto";
import { IncrementTaskContactAttemptsDto } from "../../model/task/dto/IncrementTaskContactAttemptsDto";
import { TasksSettingsPatchDto } from "../../model/task/dto/TasksSettingsPatchDto";
import { UpdateTaskDto } from "../../model/task/dto/UpdateTaskDto";
import { BaseTask } from "../../model/task/Task";
import { TasksSettings } from "../../model/task/TaskSettings";

import { AtiraApi } from "../AxiosClient";
import omit from "lodash/omit";
import { GetTaskDto } from "../../model/task/dto/GetTaskDto";

export class TaskAxios {
  static getTasksSettings(dto: GetTasksSettingsDto) {
    return AtiraApi.post<TasksSettings>(`/task/settings`, dto).then(
      ({ data }) => data,
    );
  }

  static updateTasksSettings(dto: TasksSettingsPatchDto) {
    return AtiraApi.patch<void>(`/task/settings`, dto).then(({ data }) => data);
  }

  static getAllTasks(dto: GenericGetTasksDto) {
    return AtiraApi.post<PageResponseDto<BaseTask[]>>(`/task/all`, dto).then(
      ({ data }) => data,
    );
  }

  static getTask(dto: GetTaskDto) {
    return AtiraApi.post<BaseTask>(`/task/${dto.taskId}`, dto).then(
      ({ data }) => data,
    );
  }

  static createTask(dto: CreateTaskDto) {
    const formData = new FormData();

    Object.entries(omit(dto, "image")).forEach(([key, value]) => {
      formData.append(key, isString(value) ? value : JSON.stringify(value));
    });

    if (dto.image) {
      formData.append("image", dto.image);
    }

    return AtiraApi.post<void>(`/task/create`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(({ data }) => data);
  }

  static updateTask(dto: UpdateTaskDto) {
    const formData = new FormData();

    Object.entries(omit(dto, "image")).forEach(([key, value]) => {
      formData.append(key, isString(value) ? value : JSON.stringify(value));
    });

    if (dto.image) {
      formData.append("image", dto.image);
    }

    return AtiraApi.patch<void>(`/task/${dto.taskId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(({ data }) => data);
  }

  static deleteTask(dto: DeleteTaskDto) {
    return AtiraApi.post<void>(`/task/${dto.taskId}/delete`, dto).then(
      ({ data }) => data,
    );
  }

  static assignTask(dto: AssignTaskDto) {
    return AtiraApi.post<void>(
      `/task/${dto.taskId}/manage-assignees`,
      dto,
    ).then(({ data }) => data);
  }

  static async IncrementTaskContactAttempts(
    dto: IncrementTaskContactAttemptsDto,
  ) {
    return AtiraApi.post<void>(
      `/task/${dto.taskId}/increment-contact`,
      dto,
    ).then(({ data }) => data);
  }
}
